import React from "react";
import AddSvg from "../../../components/svgComponents/AddSvg";

const BuyNewNodeButton = ({ openBuyNodeModal }) => {
  return (
    <button
      type="button"
      className=" flex justify-center items-center rounded-lg gap-2 w-full transition-all duration-300 bg-deepBlue hover:!bg-[#8C96FF] active:!bg-[#1E31FF] active:translate-x-[1px] active:translate-y-[1px] h-10 border border-white shadow-swapButton"
      onClick={openBuyNodeModal}
    >
      <AddSvg />
      <p className="text-white font-semibold text-sm leading-[21px]">
        Buy a new Node
      </p>
    </button>
  );
};

export default BuyNewNodeButton;
